export default "__VITE_ASSET__Dn03yNYj__"